module.exports = __webpack_public_path__ + "img/02g_marketing.67cb5673.jpg";